import { type FC } from 'react'

const ActiveComponent: FC = () => {
	return (
		<span className="d-inline-block bg-kumopack-success-500 p-1 rounded-circle w-2px h-2px me-1" />
	)
}

export default ActiveComponent
